import styled, { css, createGlobalStyle } from 'styled-components';
import { Select } from 'antd';

import { Button } from '~/ui/components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FilterWrapper = styled.div<{ defaultFilter?: string; disabled?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 16px;
  gap: 12px;

  @media (max-width: 1400px) {
    flex-direction: row;
    gap: 12px;
    align-items: center;

    [class*='filter-selector-']:not([class*='filter-selector-${({ defaultFilter }) => defaultFilter}']) {
      display: none;
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;

export const Content = styled.div`
  display: flex;
  gap: 8px;

  > button {
    width: max-content;
  }
`;

export const Box = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>`
  position: relative;

  .select-date {
    width: 225px !important;
  }

  .select-date-button {
    background-color: ${({ theme }) => theme.colors.background.primary};
    border-radius: 8px;
    border: 1.5px solid ${({ active, theme }) => (active ? theme.colors.brand.primary : theme.colors.divider.primary)};

    :hover {
      background-color: ${({ theme }) => theme.colors.background.secondary};
    }
  }

  :has(.react-calendar) .select-date-button {
    border-color: ${({ theme }) => theme.colors.brand.primary};
    background-color: ${({ theme }) => theme.colors.background.secondary};
  }

  label,
  .ant-cascader-picker,
  .ant-cascader-picker-label {
    font-size: 14px !important;
  }
`;

export const SearchWrapper = styled.div`
  max-width: 300px;
  width: 100%;

  div {
    background-color: ${({ theme }) => theme.colors.background.primary};
    border-width: 1px;
    height: 56px;
    border-radius: 8px;
  }
`;

export const MoreFilters = styled(Button)`
  border-radius: 8px;
  padding: 0px 18px;
  min-width: fit-content;
  border-width: 2px;

  span {
    font-size: 14px;
    font-weight: 700;
  }

  svg {
    width: 24px;
    height: 24px;
  }

  &:hover {
    border-width: 2px;
  }
`;

export const FlagDot = styled.span<{ enabled: boolean }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ enabled }) => (enabled ? '#52c41a' : '#f5222d')};
  margin-right: 8px;
  flex-shrink: 0;
`;

export const FlagOptionLabel = styled.span`
  display: inline-flex;
  align-items: center;
`;

export const FlagSelect = styled(Select)`
  width: 200px;

  .ant-select-selection {
    border-radius: 20px;
    height: 36px;
    display: flex;
    align-items: center;
    border: 1.5px solid #d9d9d9;
    background: #fff;
    box-shadow: none;

    &:hover {
      border-color: #40a9ff;
    }
  }

  .ant-select-selection__rendered {
    display: flex;
    align-items: center;
    line-height: 34px;
    margin-right: 24px;
  }

  .ant-select-selection-selected-value {
    display: flex !important;
    align-items: center;
    float: none;
  }

  .ant-select-arrow {
    right: 12px;
  }
`;

export const FlagSelectGlobalStyles = createGlobalStyle`
  .flag-select-dropdown {
    border-radius: 8px !important;
    padding: 4px 0;

    .ant-select-dropdown-menu {
      padding: 0;
    }

    .ant-select-dropdown-menu-item {
      display: flex;
      align-items: center;
      padding: 8px 16px;
      font-size: 14px;
    }

    .ant-select-dropdown-menu-item-selected {
      background-color: transparent;
      font-weight: 500;
    }
  }
`;

export const UpdateButton = styled(Button).attrs({
  variant: 'contained',
  size: 'sm',
  customColor: 'brand.secondary',
  icon: 'Refresh',
  iconPosition: 'left',
})`
  padding-inline: 16px;
  border-radius: 8px;
  white-space: nowrap;
  min-width: fit-content;

  .typography {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.brand.primary};
  }

  svg {
    color: ${({ theme }) => theme.colors.brand.primary};
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      .typography {
        color: ${({ theme }) => theme.colors.element.primary};
      }

      span,
      svg {
        color: ${({ theme }) => theme.colors.element.primary};
      }
    `}
`;

export const DownloadButton = styled(Button).attrs({
  variant: 'contained',
  size: 'sm',
  customColor: 'brand.secondary',
  icon: 'Download',
  iconPosition: 'left',
})`
  padding-inline: 16px;
  border-radius: 8px;
  white-space: nowrap;
  min-width: fit-content;

  .typography {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.brand.primary};
  }

  svg {
    color: ${({ theme }) => theme.colors.brand.primary};
    width: 16px;
    height: 16px;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      .typography {
        color: ${({ theme }) => theme.colors.element.primary};
      }

      span,
      svg {
        color: ${({ theme }) => theme.colors.element.primary};
      }
    `}
`;
